import { render, staticRenderFns } from "./declareSon.vue?vue&type=template&id=6e71bb5c&scoped=true&"
import script from "./declareSon.vue?vue&type=script&lang=js&"
export * from "./declareSon.vue?vue&type=script&lang=js&"
import style0 from "./declareSon.vue?vue&type=style&index=0&id=6e71bb5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e71bb5c",
  null
  
)

export default component.exports